import { useSelector } from 'react-redux';
import { selectors } from 'app/services/session';
import { Layout } from 'containers';
import PublicLayout from 'containers/PublicLayout/PublicLayout';

// Chooses the layout chrome for /tools/overview/:barcode and /devices/:barcode based on auth state:
// - authenticated users (even without access to this specific tool's unit) keep the
//   normal app navigation (sidebar / mobile bottom bar), matching every other page.
// - unauthenticated visitors get the minimal public shell (header only, no nav).
// The actual readonly content is rendered by the matched child route in both cases.
const ToolOverviewShell = () => {
  const isAuthenticated = useSelector(selectors.isAuthenticated);
  return isAuthenticated ? <Layout /> : <PublicLayout />;
};

export default ToolOverviewShell;
